<template>
  <div class="modal__wrapper">
    <Loader v-if="isLoading" />
    <button class="icon-button icon-button--round" @click="$modal.hide('NewCardModal')">
      <i class="ri-close-circle-fill"></i>
    </button>
    <div class="modal__card-title">
      New payment option
    </div>
    <div class="modalcard-subtitle">
      You can save as many cards as you’d like.
    </div>
    <div class="modal__card-title">
      Is this business or personal card?
    </div>
    <div class="modal__card-choice">
      <label class="radio__label">
        <input v-model="type" class="radio__input" type="radio" value="business" />
        <span class="radio__view"></span>
        <span class="radio__text">Business card</span>
      </label>
      <label class="radio__label">
        <input v-model="type" class="radio__input" type="radio" value="personal" />
        <span class="radio__view"></span>
        <span class="radio__text">Personal card</span>
      </label>
    </div>
    <form class="modal__form">
      <label class="modal__card-label modal__card-label-line">
        <div id="card-number-element" class="field"></div>
      </label>
      <label class="modal__card-label modal__card-label-line">
        <input v-model="cardName" class="modal__card-input" type="text" placeholder="Card Name" />
      </label>
      <label class="modal__card-label">
        <div id="card-expiry-element" class="field"></div>
      </label>
      <label class="modal__card-label is-hide" :class="{'is-show': isCvc}">
        <div id="card-cvc-element" class="field"></div>
      </label>
      <div id="addCvc" class="modal__button--cvc" :class="{'is-hide': isCvc}">Add CVC</div>
      <div id="sendBtn" class="modal__button">
        <span class="modal__button-text">Save this method</span>
      </div>
    </form>
  </div>
</template>

<script>
import {loadStripe} from '@stripe/stripe-js'
import Loader from '@/components/Loader'

export default {
  name: 'PublicNewOrderPayment',
  components: {Loader},
  props: {
    pickup: {
      type: Object,
      default: null
    },
    dropOff: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      type: 'business',
      cardName: null,
      isLoading: false,
      isCvc: false,
      saving: false
    }
  },
  async mounted() {
    const stripe = await loadStripe(process.env.VUE_APP_STRIPE_KEY)
    const elements = stripe.elements()

    const style = {
      base: {
        fontSize: '14px',
        '::placeholder': {
          color: '#CFD7E0'
        }
      }
    }

    const cardNumberElement = elements.create('cardNumber', {style, showIcon: true})
    cardNumberElement.mount('#card-number-element')

    const cardExpiryElement = elements.create('cardExpiry', {style})
    cardExpiryElement.mount('#card-expiry-element')

    const btn = document.getElementById('sendBtn')
    // No {once: true}: it detached the listener after the FIRST click, so one
    // declined card left the Save button permanently dead until a reload. The
    // saving flag replaces it as the double-submit guard.
    btn.addEventListener('click', async () => {
      if (this.saving) return
      this.saving = true
      try {
        const {token, error} = await stripe.createToken(cardNumberElement)
        if (error || !token) {
          alert(error ? error.message : 'Could not read the card. Please check the details and try again.')
          return
        }
        this.isLoading = true
        try {
          await this.$store.dispatch('card/add', {
            token: token.id,
            cardType: this.type,
            cardName: this.cardName
          })
          this.$modal.hide('NewCardModal')
        } catch (e) {
          alert('Could not save the card. Please try again.')
        } finally {
          this.isLoading = false
        }
      } finally {
        this.saving = false
      }
    })
    const addCvcBtn = document.getElementById('addCvc')
    addCvcBtn.addEventListener(
      'click',
      () => {
        this.isCvc = true
        const cardCvcElement = elements.create('cardCvc', {style})
        cardCvcElement.mount('#card-cvc-element')
      },
      {once: true}
    )
  }
}
</script>

<style lang="scss" scoped>
@import 'style';
</style>
